import React from 'react'
import { __, getLanguage } from '../lib/helpers'

class Footer extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
          
    let linkImprint, linkPrivacy
    let location = getLanguage().toUpperCase()
    switch(location) {
        case 'DE' :
          linkImprint = 'https://sonnenbatterie.de/de/impressum'
          linkPrivacy = 'https://sonnenbatterie.de/de/datenschutz'
          break
        case 'EN' :
          linkImprint = 'https://sonnenbatterie.de/en/imprint-0'
          linkPrivacy = 'https://sonnenbatterie.de/en/privacy-policy'
          break
        case 'IT' :
          linkImprint = 'https://www.sonnenbatterie.de/it/node/972'
          linkPrivacy = 'https://sonnenbatterie.de/it/privacy'
          break
    }
    
    
    return (
      <div className="Footer">
        <a href={linkImprint} target="_blank">{__('Footer.imprint')}</a>
        &nbsp;|&nbsp;
        <a href={linkPrivacy} target="_blank">{__('Footer.privacy')}</a>
      </div>
    )
  }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.js